module.exports = __webpack_public_path__ + "img/Camilo-Plazas-.7c7df166.png";